/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { Status } from "../../models/status";
import { TemplateRead } from "../../models/template-read";
import { TemplateUpdate } from "../../models/template-update";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface UpdateTemplate$Params {
  organisation_id: string;
  template_id: number;
  check?: boolean;
  body: TemplateUpdate;
}

export function updateTemplate(
  http: HttpClient,
  rootUrl: string,
  params: UpdateTemplate$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<TemplateRead | Status>> {
  const rb = new RequestBuilder(rootUrl, updateTemplate.PATH, "patch");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("template_id", params.template_id, {});
    rb.query("check", params.check, {});
    rb.body(params.body, "application/json");
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TemplateRead | Status>;
    }),
  );
}

updateTemplate.PATH = "/surfdomeinen/organisations/{organisation_id}/templates/{template_id}";
